import { PDFDocument } from "@cantoo/pdf-lib";
import { blobFromArrayBufferAsync } from "src/app/support/blob";

export async function pdfMergeDocuments(pdfBlobs: Blob[]): Promise<Blob> {
  const pdfMasterDocument = await PDFDocument.create();

  for (let pdfBlob of pdfBlobs) {
    const pdfBytes = await pdfBlob.arrayBuffer();
    const pdfDocument = await PDFDocument.load(pdfBytes);

    const pages = await pdfMasterDocument.copyPages(
      pdfDocument,
      pdfDocument.getPageIndices()
    );

    pages.forEach((page) => {
      pdfMasterDocument.addPage(page);
    });
  }

  return await blobFromArrayBufferAsync(
    // @ts-ignore [expect-error]: 🐛 There is a null/undefined issue here which could cause bugs! Please fix me.
    (await pdfMasterDocument.save()).buffer
  );
}
